module.exports = __webpack_public_path__ + "img/noc.bc84eda8.svg";